import { combineReducers } from 'redux';
import keywordReducer from './keywordReducer';
import folderReducer from './folderReducer';
import * as types from '../actionTypes'; // Import action types

const appReducer = combineReducers({
  keywords: keywordReducer,
  folders: folderReducer,
  // other reducers would go here
});

const rootReducer = (state, action) => {
  if (action.type === types.RESET_APP_STATE) {
    // Passing undefined to appReducer will cause each slice reducer
    // to return its initialState.
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
